import React from 'react';
import Icon from '../AppIcon';

export const Checkbox = ({ label, checked, onChange, name, error, disabled = false, ...props }) => {
  const checkboxId = `checkbox-${name}`;
  const errorId = `${checkboxId}-error`;

  return (
    <div className="checkbox-wrapper">
      <div className="flex items-start gap-3">
        <div className="flex items-center h-5">
          <input
            id={checkboxId}
            type="checkbox"
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="sr-only peer"
            aria-invalid={!!error}
            aria-describedby={error ? errorId : undefined}
            {...props}
          />
          <label
            htmlFor={checkboxId}
            className={`w-5 h-5 border-2 rounded flex items-center justify-center cursor-pointer transition-all duration-200 ${
              error 
                ? 'border-error' :'border-border peer-checked:border-primary peer-checked:bg-primary'
            } peer-focus:ring-2 peer-focus:ring-primary/20 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed`}
          >
            {checked && (
              <Icon name="Check" size={14} color="white" />
            )}
          </label>
        </div>
        {label && (
          <label 
            htmlFor={checkboxId} 
            className={`text-sm text-foreground cursor-pointer select-none flex-1 ${
              disabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {label}
          </label>
        )}
      </div>
      {error && (
        <p id={errorId} className="mt-1 ml-8 text-sm text-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default Checkbox;